<template>
    <div class="flex flex-col items-center justify-center max-h-40 ">
        <input ref="fileInput" type="file" class="hidden" @input="pickFile" />

        <img
            :src="picture"
            class="block w-32 bg-center bg-cover cursor-pointer "
            @click="selectImage"
        />
        <div class="">
            <!-- <p> -->
            <!-- Progress: {{ uploadValue.toFixed() + "%" }} -->
            <progress
                id="progress"
                class="w-40 h-2 rounded-full"
                :value="uploadValue"
                max="100"
            ></progress>
            <!-- </p> -->
        </div>
        <base-secondary-button @click="onUpload" title="Ajouter une image" />
    </div>
</template>

<script>
import { storage } from "@/services/firebase.service";
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        id: {
            required: true
        },
        value: {
            type: String
        }
    },
    data() {
        return {
            picture:
                this.value === null ? "/default-placeholder.png" : this.value,
            uploadValue: 0,
            imageData: null
        };
    },

    methods: {
        selectImage() {
            this.$refs.fileInput.click();
        },
        pickFile() {
            this.uploadValue = 0;
            let input = this.$refs.fileInput;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.onload = e => {
                    this.picture = e.target.result;
                };
                reader.readAsDataURL(file[0]);
                this.imageData = file[0];
            }
        },

        onUpload() {
            const storageRef = storage
                .ref(`${this.$route.params.uid}/${this.title}/${this.id}`)
                .put(this.imageData);
            storageRef.on(
                `state_changed`,
                snapshot => {
                    this.uploadValue =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                error => {
                    console.log(error.message);
                },
                () => {
                    this.uploadValue = 100;
                    storageRef.snapshot.ref.getDownloadURL().then(url => {
                        this.picture = url;
                        this.$emit("input", this.picture);
                    });
                }
            );
        }
    }
};
</script>
<style></style>
